const parseStoryIndex = (indices) => ({
  story: {
    ids: indices.ids,
  },
})

const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'DESERIALIZER_INDEXING': {
      const { payloadIndices } = action.payload

      if (payloadIndices.type === 'story') {
        return parseStoryIndex(payloadIndices)
      }

      return state
    }
    default:
      return state
  }
}

export default reducer
